import { render, staticRenderFns } from "./resolveAddressList.vue?vue&type=template&id=efd3b314&scoped=true"
import script from "./resolveAddressList.vue?vue&type=script&lang=js"
export * from "./resolveAddressList.vue?vue&type=script&lang=js"
import style0 from "./resolveAddressList.vue?vue&type=style&index=0&id=efd3b314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd3b314",
  null
  
)

export default component.exports